<meta name="viewport" content="width=850">
<div class="wrapper" *ngIf="listing">
    <div class="item1">
        <div class="item1a">
            <div class="remax-logo-container">
                <img class="remax-logo print-page-image" src="{{ '/assets/REMAX_Logo/REMAX_mastrLogotype_RGB_R.png' }}" />
            </div>
            <div class="dates-container">
                <ng-container *ngIf="listing.listingDate != null">
                    {{ 'listing-summary.date-listed' | translate }} {{ listing.listingDate | date }} |
                </ng-container>
                <ng-container *ngIf="listing.lastUpdated != null">
                    {{ 'details.last-updated' | translate }}: {{ listing.lastUpdated | date }}
                </ng-container>
            </div>
        </div>
        <div class="agent-container">
            <ng-container *ngIf="listing.agent != null">
                <div class="agent-photo-container">
                    <img class="agent-photo print-page-image"
                        src="{{ listing.agent.associatePhoto }}" 
                        onerror="
                            this.onerror = null;
                            this.src = '/assets/BalloonLarge.svg';" />
                </div>
                <div class="agent-info-container">
                    <div class="agent-name">
                        {{ listing.agent.firstName }} {{ listing.agent.lastName }}
                    </div>
                    <div class="agent-details">
                        <div>
                            {{ listing.agent.email }}
                        </div>
                        <div>
                            {{ listing.agent.parsedPhoneNumber }}
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="qr-code-container">
            <qr-code class="qr-code-img" 
                [value]="serverUrl + listing.detailUrl + '?print=true'" 
                [size]="85">
            </qr-code>
        </div>
    </div>
    <div class="item2">
        <div class="item2a">
            <ng-container *ngIf="listing.isLuxury; then lux"></ng-container>
            <ng-container *ngIf="listing.isCommercial; then com"></ng-container>
            <ng-container *ngIf="!listing.isLuxury && !listing.isCommercial; then res"></ng-container>
            <ng-template #lux>
                <img class="listing-photo print-page-image"
                    src="{{ listing.imageUrls[0] }}" 
                    onerror="
                        this.onerror = null;
                        this.src = '/assets/listing-default-image/luxury_placeholder@1x.svg';" />
            </ng-template>
            <ng-template #com>
                <img class="listing-photo print-page-image" 
                    src="{{ listing.imageUrls[0] }}" 
                    onerror="
                        this.onerror = null;
                        this.src = '/assets/listing-default-image/commercial_placeholder@1x.svg';" />
            </ng-template>
            <ng-template #res>
                <img class="listing-photo print-page-image" 
                    src="{{ listing.imageUrls[0] }}" 
                    onerror="
                        this.onerror = null;
                        this.src = '/assets/listing-default-image/residential_placeholder@1x.svg';" />
            </ng-template>
        </div>
        <div class="item2b">
            <div class="item2b_i">
                <div class="listing-price">
                    {{ listing.listPrice | currency:'CAD':'symbol-narrow':'1.0-0' }} </div>
                <div>
                    <div class="mls-num" *ngIf="listing.mlsNum">
                        {{ 'details.mls-num' | translate }}: {{ listing.mlsNum }}
                    </div>
                </div>
            </div>     
            <div class="item2b_ii">
                <div class="address"> 
                    {{ listing.address.toLowerCase() }} 
                </div>
                <div class="address-supplementary">
                    <app-listing-address 
                        [parts]="[listing.communityName, listing.city, listing.province, listing.postalCode | formatPostalCode]">
                    </app-listing-address>
                </div>
            </div>
            <div class="item2b_iii">
                <table class="detail-tbl room-detail-tbl">
                    <ng-container *ngFor="let detail of listing.roomDetailRows">
                        <tr *ngIf="detail.value != null">
                            <td>
                                <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                                <div class="table-cell-text">
                                    {{ detail.title | translate }}
                                </div>
                            </td>
                            <td>
                                <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                                <div class="table-cell-text">
                                    {{ detail.value }}
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </div>
        </div>
    </div>
    <div class="item3">
        {{ listing.description }}
    </div>
    <div class="item4">
        <div>
            <table align="left" class="detail-tbl key-facts-tbl">
                <tr>
                    <th colspan="2">{{ 'details.key-facts' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[0]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[0].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>
            <table align="left" class="detail-tbl addl-features-tbl">
                <tr>
                    <th colspan="2">{{ 'details.features' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[5]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[5].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div>
            <table align="center" class="detail-tbl inside-tbl">
                <tr>
                    <th colspan="2">{{ 'details.inside' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[1]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[1].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>  
            <table align="center" class="detail-tbl utility-tbl">
                <tr>
                    <th colspan="2">{{ 'details.utilities' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[4]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[4].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>          
        </div>
        <div>
            <table align="right" class="detail-tbl outside-tbl">
                <tr>
                    <th colspan="2">{{ 'details.outside' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[2]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[2].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>
            <table align="right" class="detail-tbl high-detail-tbl">
                <tr>
                    <th colspan="2">{{ 'details.details' | translate | uppercase }}</th>
                </tr>
                <ng-container *ngFor="let detail of filteredDetails[3]">
                    <tr>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.title | translate }}
                            </div>
                        </td>
                        <td>
                            <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                            <div class="table-cell-text">
                                {{ detail.value == null || detail.value.trim() == '' ? ('na' | translate) : detail.value }}
                            </div>
                        </td>
                    </tr>
                </ng-container>
                <tr *ngIf="filteredDetails[3].length === 0">
                    <td colspan="2">
                        <img class="table-cell-bg" src="{{ '/assets/table-cell-bg.png' }}" />
                        <div class="ask-agent-text">
                            {{ 'details.ask-agent' | translate }}
                        </div>
                    </td>
                </tr>
            </table>
        </div>        
    </div>
</div>